import { useRouter } from 'next/router';
import { useMutation } from '@apollo/client';
import { StartApplicationDocument } from '../../graphql/queries';
import { useEffect } from 'react';
import { TallHeightLoadingMask } from '../../styles/styled-components';
import { getEditRoute } from '../../constants/urls';
import { STEP_IDS } from '../../constants/wizard';
import { logError } from '@zg-rentals/log-error';
import { REQUESTING_CLIENT } from '../../constants/api';
import { BRANDS } from '../../constants/brands';

export function ApplicationCreate() {
  const router = useRouter();
  const { listingAlias, utm_source, utm_medium, utm_guid, utm_campaign } = router.query;

  const utmGuid = String(utm_guid ?? '');
  const utmCampaign = String(utm_campaign ?? '');
  const utmMedium = String(utm_medium ?? '');
  const utmSource = String(utm_source ?? '');
  const referrerBrand = Object.values(BRANDS).includes(utmSource) ? utmSource : null;

  const [startApplicationMutation] = useMutation(StartApplicationDocument);

  async function startApplication() {
    try {
      const response = await startApplicationMutation({
        variables: {
          listingAlias: String(listingAlias ?? ''),
          requestingClient: REQUESTING_CLIENT,
          utmSource,
          utmMedium,
          utmGuid,
          utmCampaign,
          referrerBrand,
        },
      });
      const applicationId = response.data?.startApplication?.id;
      if (applicationId) {
        router.push(getEditRoute({ applicationId, stepId: STEP_IDS.LEGAL_NAME }));
      }
    } catch (err) {
      logError({ error: err, context: 'ApplicationCreate - useStartApplication hook error' });
      router.push('/');
    }
  }

  useEffect(() => {
    if (listingAlias) {
      startApplication();
    }
  }, [listingAlias]);

  return (
    <TallHeightLoadingMask>
      <></>
    </TallHeightLoadingMask>
  );
}
